module.exports = __webpack_public_path__ + "img/08-TOP-CALA-U--STAMPE-VOILE-----GONNA-VODKA-U-STAMPE-LINO2.6f73e59f.jpg";